module.exports = __webpack_public_path__ + "static/media/juice.ecde269d.svg";